import { useEffect, useImperativeHandle, useState } from 'react';
import './section-modify.less';
import { Input, message, Image } from 'antd';
import { useParams } from 'react-router-dom';
import { PSection, ParamIn } from '@/commons/interface/speccommon/section';
import { updateSection } from '@/api/spec-common/section';
import { getSectionTypeItemInfo } from '@/commons/enums/speccommon/section';
import { ParamUnits, convertToSuperscript } from '@/commons/utils/unit';
import { floatVerification } from '@/commons/utils/antd-input';


interface IProps {
    section: PSection
    goBack: (mode: string) => void
    width: number
}

export default function SectionModify(props: IProps, ref) {

    const { projectUuid } = useParams();
    const [data, setData] = useState<ParamIn>(null);
    const [newSection, setNewSection] = useState<PSection>({});
    const [nameStr, setNameStr] = useState<string>('');
    // const [btnLoading, setBtnLoading] = useState<boolean>(false);

    useImperativeHandle(ref, () => ({
        handleInsert: handleInsert,
    }))

    useEffect(() => {
        if (!props?.section?.paramIn) return;
        let paramInKey: string[] = []
        let section = {}
        Object.keys(props.section?.paramIn).forEach(item => {
            paramInKey.push(item);
            section[item] = props.section?.paramIn[item]
            if (typeof props.section?.paramIn[item] === 'number') {
                section[item] = props.section?.paramIn[item] * 1000;
            } else {
                section[item] = props.section?.paramIn[item];
            }
        })
        let parIn: ParamIn = {
            id: props.section?.type,
            paramIn: paramInKey
        }
        setData(parIn);
        setNewSection(section);
        setNameStr(props.section?.name);
    }, [props.section])


    const paramInChange = (value: string, field: string) => {
        // 使用floatVerification函数来格式化输入的值
        const formattedValue = floatVerification(value);

        // 直接更新状态，使用格式化后的值
        let newV = { ...newSection };
        newV[field] = formattedValue; // 使用格式化后的字符串更新状态
        setNewSection(newV);
    }

    const paramInBlur = (field: string) => {
        let newS = { ...newSection };
        let newV = newS[field];
        if (typeof newV === 'number') {
            newV = newV.toString();
        }
        let formatValue = floatVerification(newV);

        newS[field] = formatValue;
        setNewSection(newS);
    }

    const handleInsert = () => {
        if (!nameStr) {
            message.warning("参数不完整");
            return;
        }
        let flag = false;
        data?.paramIn?.forEach(item => {
            if (!newSection[item]) {
                flag = true;
            }
        })
        if (flag) {
            message.warning("参数不完整");
            return;
        }
        let par: PSection = {
            name: nameStr,
            type: props.section?.type,
            paramIn: JSON.parse(JSON.stringify(newSection)),
            projectUuid: projectUuid,
            isSelfDefine: true,
        }
        Object.keys(newSection).forEach(key => {
            // 如果 newSection[key] 是字符串，并且可以被解析为有效的浮点数或整数
            if (typeof newSection[key] === 'string' && !isNaN(parseFloat(newSection[key]))) {
                // 将字符串转换为浮点数(或整数，如果使用 parseInt)
                const numericValue = parseFloat(newSection[key]);
                // 现在可以将转换后的数字值除以 1000
                par.paramIn[key] = numericValue / 1000;
            } else if (typeof newSection[key] === 'number') {
                // 如果本来就是数字，则直接除以 1000
                par.paramIn[key] = newSection[key] / 1000;
            }
            // 如果 newSection[key] 既不是数字也不是可转换为数字的字符串，
            // 则不进行修改，保留 par.paramIn[key] 的初始值（从 newSection 浅拷贝过来的值）
        });
        // setBtnLoading(true);
        updateSection(props.section?.id, par).then(res => {
            if (res.status === 200) {
                message.success("修改成功");
                props.goBack('lib');
            }
        }).catch(err => {
            message.error("修改失败");
        }).finally(() => {
            setNewSection({});
            setNameStr("");
            // setBtnLoading(false);
        })
    }

    return (
        <div className='section-modify-panel'>
            <div className='img-area'>
                <Image
                    width={200}
                    height={200}
                    src={getSectionTypeItemInfo(props.section?.type)?.image}
                    preview={false}
                />
            </div>
            <div className='message-area'>
                <div className='message' style={{ width: props.width - 32 }}>
                    <div className='param-name'>名称</div>
                    <div className='value'>
                        <Input
                            value={nameStr}
                            onChange={(e) => setNameStr(e.target.value)}
                        />
                    </div>
                </div>
                {data?.paramIn?.map((item, idx) => (
                    <div key={idx} className='message' style={{ width: props.width - 32 }}>
                        <div className='param-name'>{item}</div>
                        <div className='value'>
                            <Input
                                value={newSection[item]}
                                onChange={(e) => paramInChange(e.target.value, item)}
                                onBlur={() => paramInBlur(item)}
                            />
                        </div>
                        <div className='unit' dangerouslySetInnerHTML={{ __html: convertToSuperscript(ParamUnits[item]) }} />
                    </div>
                ))}
            </div>
            {/* <div className='footer'>
                <Button className='btn add' onClick={handleInsert} loading={btnLoading}>确定</Button>
                <Button className='btn cancel' onClick={() => { props.goBack('lib'); }}>取消</Button>
            </div> */}
            {/* <div className='bottom-footer'>
                <Button className='btn-save' onClick={handleInsert} loading={btnLoading}>确认</Button>
                <Button className='btn-cancel' onClick={() => { props.goBack('lib'); }}>取消</Button>
            </div> */}
        </div>

    )
}